import React, { useEffect, useState } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Table,
  Label,
  Input,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import gig from "../../assets/images/what.gif"
import { URLS } from "../../Url"
import axios from "axios"

function DigitalBrochure() {
  const [isLoading, setIsLoading] = useState(false)

  const [form, setform] = useState([])

  const [forms, setforms] = useState([])

  const handlechange = e => {
    const myform = { ...forms }
    myform[e.target.name] = e.target.value
    setforms(myform)
  }

  useEffect(() => {
    GetAllBroucher()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const GetAllBroucher = () => {
    var token = datas

    axios
      .post(
        URLS.GetContactUs,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setform(res.data.contactus)
        setforms(res.data.contactus)
        setIsLoading(false)
      })
  }
  const [modal_small, setmodal_small] = useState(false)
  function tog_small() {
    setmodal_small(!modal_small)
  }

  const getpopup1 = () => {
    tog_small()
  }

  const submibooking = e => {
    e.preventDefault()

    changstatus()
  }

  const changstatus = () => {
    var token = datas
    const Data = {
      name: forms.name,
      description: forms.description,
      email: forms.email,
      phone: forms.phone,
      toTime: forms.toTime,
      fromTime: forms.fromTime,
      alternatePhone: forms.alternatePhone,
    }

    axios
      .put(URLS.UpdateContactUs, Data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setmodal_small(false)
            GetAllBroucher()
            setIsLoading(true)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
            setIsLoading(false)
          }
        }
      )
  }
  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="Contact Us" />
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader className="bg-white"></CardHeader>
                {isLoading == true ? (
                  <>
                    <div
                      style={{ zIndex: "9999999999999", height: "420px" }}
                      className="text-center mt-5 pt-5"
                    >
                      <img src={gig} height="140px"></img>
                      <div>Loading......</div>
                    </div>
                  </>
                ) : (
                  <>
                    <CardBody>
                      <Row>
                        <Col md={12}>
                          <div style={{ float: "right" }}>
                            {Roles?.SettingsEdit == true ||
                            Roles?.accessAll == true ? (
                              <>
                                <Button
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Edit Booking"
                                  onClick={() => {
                                    getpopup1(form)
                                  }}
                                  className="mr-5 mb-1 m-1 "
                                  color="success"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-edit m-1"></i>
                                      Edit
                                    </small>
                                  </div>
                                </Button>
                              </>
                            ) : (
                              ""
                            )}
                          </div>{" "}
                        </Col>
                      </Row>
                      <Row className="d-flex justified-content-centerd-flex justify-content-center">
                        <Col md={10}>
                          <div>
                            <div className="table-rep-plugin mt-4 table-responsive">
                              <Table
                                hover
                                className="table table-bordered mb-4"
                              >
                                <thead>
                                  <tr>
                                    <th className="text-center">Office Name</th>
                                    <td>{form.name}</td>
                                  </tr>
                                  <tr>
                                    <th className="text-center">
                                      Office Email
                                    </th>
                                    <td>{form.email}</td>
                                  </tr>
                                  <tr>
                                    <th className="text-center">
                                      Office Phone Number
                                    </th>
                                    <td>{form.phone}</td>
                                  </tr>
                                  {/* adding new */}
                                  <tr>
                                    <th className="text-center">
                                      Office Alternative Phone Number
                                    </th>
                                    <td>{form.alternatePhone}</td>
                                  </tr>
                                  <tr>
                                    <th className="text-center">
                                      Office Location{" "}
                                    </th>
                                    <td>{form.description}</td>
                                  </tr>
                                  <tr>
                                    <th className="text-center">
                                      From Time / To Time{" "}
                                    </th>
                                    <td>
                                      {form.fromTime} / {form.toTime}
                                    </td>
                                  </tr>
                                </thead>
                              </Table>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </>
                )}
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            isOpen={modal_small}
            toggle={() => {
              tog_small()
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                Edit Contact Us
              </h5>
              <button
                onClick={() => {
                  setmodal_small(false)
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form
                onSubmit={e => {
                  submibooking(e)
                }}
              >
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Office Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Office Name"
                        required
                        value={forms.name}
                        name="name"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Office Email<span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter Office Email"
                            required
                            value={forms.email}
                            name="email"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Office Phone Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter Office Phone Number"
                            required
                            value={forms.phone}
                            name="phone"
                            onChange={e => {
                              handlechange(e)
                            }}
                            maxLength="10"
                            minLength="10"
                            pattern="[0-9]{10}"
                            onKeyPress={e => {
                              // Allow only numeric input
                              const charCode = e.which ? e.which : e.keyCode
                              if (charCode < 48 || charCode > 57) {
                                e.preventDefault()
                              }
                            }}
                          />
                        </div>
                      </Col>
                      {/* adding the alternative number */}
                      <Col md={6}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Office Alternative Phone Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter Phone Number"
                            required
                            value={forms.alternatePhone}
                            name="alternatePhone"
                            onChange={e => {
                              handlechange(e)
                            }}
                            maxLength="10"
                            minLength="10"
                            pattern="[0-9]{10}"
                            onKeyPress={e => {
                              // Allow only numeric input
                              const charCode = e.which ? e.which : e.keyCode
                              if (charCode < 48 || charCode > 57) {
                                e.preventDefault()
                              }
                            }}
                          />
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            From Time <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="time"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter From Time"
                            required
                            value={forms.fromTime}
                            name="fromTime"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            To Time <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="time"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter To Time"
                            required
                            value={forms.toTime}
                            name="toTime"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Location <span className="text-danger">*</span>
                      </Label>
                      <textarea
                        type="text"
                        rows="5"
                        className="form-control "
                        id="basicpill-firstname-input1"
                        placeholder="Enter Location"
                        required
                        value={forms.description}
                        name="description"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <hr></hr>
                <div style={{ float: "right" }} className="m-2">
                  <Button className="m-1" type="submit">
                    Submit <i className="fas fa-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default DigitalBrochure
